import { useNavigate } from 'react-router-dom'
import { MdMenu, MdMenuOpen } from 'react-icons/md'
import { useUser } from '../context/UserContext'

const Header = ({ sidebarOpen = true, onToggleSidebar }) => {
  const navigate = useNavigate()
  const { clearUser } = useUser()

  const handleLogout = () => {
    clearUser()
    navigate('/login')
  }

  return (
    <header className="bg-white border-b border-gray-200 h-12 flex items-center justify-between px-6 fixed top-0 left-0 right-0 z-50">
      <div className="flex items-center gap-2">
        {typeof onToggleSidebar === 'function' && (
          <button
            type="button"
            onClick={onToggleSidebar}
            className="p-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors"
            title={sidebarOpen ? 'Ocultar menú lateral' : 'Mostrar menú lateral'}
            aria-expanded={sidebarOpen}
            aria-label={sidebarOpen ? 'Ocultar menú lateral' : 'Mostrar menú lateral'}
          >
            {sidebarOpen ? (
              <MdMenuOpen className="w-6 h-6" aria-hidden />
            ) : (
              <MdMenu className="w-6 h-6" aria-hidden />
            )}
          </button>
        )}
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <img src="/img/logo.png" alt="MGC Logo" className="w-8 h-8" />
          </div>
          <span>
            <span className="text-xl font-semibold text-gray-500">MGC</span>
            <span className="text-xl text-gray-600">Interfactor</span>
          </span>
        </div>
      </div>
      
      <button 
        onClick={handleLogout}
        className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span>Cerrar Sesión</span>
      </button>
    </header>
  )
}

export default Header